// Both forms keep transaction segment 16. Preserve the legacy RC payload while
// the configurable Cartório form uses the identification fields from PDV Notas.
export function buildCartorioSale(values: any) {
  const notasForm = values?.dsIdentificacaoServico !== undefined;
  return {
    dsIdentificacaoCliente: notasForm
      ? values.dsIdentificacaoCliente
      : values?.client,
    ...(notasForm
      ? { dsIdentificacaoServico: values.dsIdentificacaoServico }
      : {}),
    vlServicos: (notasForm ? values.total : values?.service) || 0,
    SenhaAtendimento: values?.att_password || '',
  };
}
